<div class="row subheader-text pt-3">
  <div class="col-md-7 d-flex align-items-center justify-content-start pl-0">
    <button *ngIf="!subTaskToggleBtn" title="toggle" pButton pRipple type="button" icon="pi pi-chevron-circle-down"
      class="p-button-rounded p-button-text" (click)="toggleSubTask()"></button>
    <button *ngIf="subTaskToggleBtn" title="toggle" pButton pRipple type="button" icon="pi pi-chevron-circle-up"
      class="p-button-rounded p-button-text" (click)="toggleSubTask()"></button>
    <span class="first-span" (click)="toggleSubTask()" style="cursor:pointer;">
      <img src="../../../../../assets/images/Petition_icon.png" alt="Petition" style="width: 50px; height: 29.6px;" /> I
      - 140
    </span>
    <span>Status : {{task?.taskStatus?.name}} </span>
    <span *ngIf="task?.decisionName">Decision :{{task?.decisionName}} </span>
    <span class="last-span" *ngIf="filingDate"> Priority Date : {{filingDate | I140DateFormat}}</span>
  </div>
  <div class="col-md-5 d-flex align-items-center justify-content-end pr-0">
    <!-- <button pButton type="button" label="Create I-485 Task" title="Create I-485 Task" (click)="createI485Task()"
      *ngIf="userType && userType !=='Beneficiary' && i485Present === false" class="p-button-outlined"
      [ngClass]="{'disabled': !(task && task.taskStatus && task.taskStatus.code && task.taskStatus.code === 'APPROVED')}"
      [disabled]="!(task && task.taskStatus && task.taskStatus.code && task.taskStatus.code === 'APPROVED')"></button>
      <button pButton type="button" label="Create DS-260 Task" title="Create DS-260 Task" (click)="createDS260Task()"
      *ngIf="userType && userType !=='Beneficiary' && ds260Present === false"
      class="p-button-outlined"
      [ngClass]="{'disabled': !(task && task.taskStatus && task.taskStatus.code && task.taskStatus.code === 'APPROVED')}"
      [disabled]="!(task && task.taskStatus && task.taskStatus.code && task.taskStatus.code === 'APPROVED')"></button> -->
    <button pButton type="button" label="Update Decision" title="Update Decision"
      [disabled]="isUpdateDecisionBtnDisabled" (click)="handleUpdateDecision()" class="p-button-outlined"
      [ngClass]="isUpdateDecisionBtnDisabled ? 'disabled' : 'p-button-outlined'"></button>
    <button pButton type="button" label="Send Notification" title="Send Notification" (click)="handleSendNotification()"
      class="p-button-outlined"></button>
  </div>
</div>
